import _ISdtfIntegration from "./integrations/ISdtfIntegration";
import _ISdtfTypeReader from "./integrations/ISdtfTypeReader";
import _ISdtfTypeWriter from "./integrations/ISdtfTypeWriter";
import _ISdtfBaseReadableComponent from "./reader/components/ISdtfBaseReadableComponent";
import _ISdtfReadableAccessor from "./reader/components/ISdtfReadableAccessor";
import _ISdtfReadableAsset from "./reader/components/ISdtfReadableAsset";
import _ISdtfReadableAttributes from "./reader/components/ISdtfReadableAttributes";
import _ISdtfReadableBuffer from "./reader/components/ISdtfReadableBuffer";
import _ISdtfReadableBufferView from "./reader/components/ISdtfReadableBufferView";
import _ISdtfReadableChunk from "./reader/components/ISdtfReadableChunk";
import _ISdtfReadableDataItem from "./reader/components/ISdtfReadableDataItem";
import _ISdtfReadableFileInfo from "./reader/components/ISdtfReadableFileInfo";
import _ISdtfReadableNode from "./reader/components/ISdtfReadableNode";
import _ISdtfReadableTypeHint from "./reader/components/ISdtfReadableTypeHint";
import _ISdtfBufferValue from "./reader/ISdtfBufferValue";
import _ISdtfParser from "./reader/ISdtfParser";
import _ISdtfReadableContentComponent from "./reader/ISdtfReadableContentComponent";
import _ISdtfAccessor from "./structure/components/ISdtfAccessor";
import _ISdtfAsset from "./structure/components/ISdtfAsset";
import _ISdtfAttributes from "./structure/components/ISdtfAttributes";
import _ISdtfBaseComponent from "./structure/components/ISdtfBaseComponent";
import _ISdtfBuffer from "./structure/components/ISdtfBuffer";
import _ISdtfBufferView from "./structure/components/ISdtfBufferView";
import _ISdtfChunk from "./structure/components/ISdtfChunk";
import _ISdtfDataItem from "./structure/components/ISdtfDataItem";
import _ISdtfFileInfo from "./structure/components/ISdtfFileInfo";
import _ISdtfNode from "./structure/components/ISdtfNode";
import _ISdtfTypeHint from "./structure/components/ISdtfTypeHint";
import _SdtfShapeDiverTypeHints from "./structure/SdtfShapeDiverTypeHints";
import _SdtfTypeGuards from "./utils/SdtfTypeGuards";
import _SdtfUtils from "./utils/SdtfUtils";
import _ISdtfBaseWriteableComponent from "./writer/components/ISdtfBaseWriteableComponent";
import _ISdtfWriteableAccessor from "./writer/components/ISdtfWriteableAccessor";
import _ISdtfWriteableAsset from "./writer/components/ISdtfWriteableAsset";
import _ISdtfWriteableAttributes from "./writer/components/ISdtfWriteableAttributes";
import _ISdtfWriteableBuffer from "./writer/components/ISdtfWriteableBuffer";
import _ISdtfWriteableBufferView from "./writer/components/ISdtfWriteableBufferView";
import _ISdtfWriteableChunk from "./writer/components/ISdtfWriteableChunk";
import _ISdtfWriteableDataItem from "./writer/components/ISdtfWriteableDataItem";
import _ISdtfWriteableFileInfo from "./writer/components/ISdtfWriteableFileInfo";
import _ISdtfWriteableNode from "./writer/components/ISdtfWriteableNode";
import _ISdtfWriteableTypeHint from "./writer/components/ISdtfWriteableTypeHint";
import _ISdtfWriteableComponentFactory from "./writer/ISdtfWriteableComponentFactory";
import _SdtfError from "./SdtfError";
var exports = {};
var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = exports && exports.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
__exportStar(_ISdtfIntegration, exports);
__exportStar(_ISdtfTypeReader, exports);
__exportStar(_ISdtfTypeWriter, exports);
__exportStar(_ISdtfBaseReadableComponent, exports);
__exportStar(_ISdtfReadableAccessor, exports);
__exportStar(_ISdtfReadableAsset, exports);
__exportStar(_ISdtfReadableAttributes, exports);
__exportStar(_ISdtfReadableBuffer, exports);
__exportStar(_ISdtfReadableBufferView, exports);
__exportStar(_ISdtfReadableChunk, exports);
__exportStar(_ISdtfReadableDataItem, exports);
__exportStar(_ISdtfReadableFileInfo, exports);
__exportStar(_ISdtfReadableNode, exports);
__exportStar(_ISdtfReadableTypeHint, exports);
__exportStar(_ISdtfBufferValue, exports);
__exportStar(_ISdtfParser, exports);
__exportStar(_ISdtfReadableContentComponent, exports);
__exportStar(_ISdtfAccessor, exports);
__exportStar(_ISdtfAsset, exports);
__exportStar(_ISdtfAttributes, exports);
__exportStar(_ISdtfBaseComponent, exports);
__exportStar(_ISdtfBuffer, exports);
__exportStar(_ISdtfBufferView, exports);
__exportStar(_ISdtfChunk, exports);
__exportStar(_ISdtfDataItem, exports);
__exportStar(_ISdtfFileInfo, exports);
__exportStar(_ISdtfNode, exports);
__exportStar(_ISdtfTypeHint, exports);
__exportStar(_SdtfShapeDiverTypeHints, exports);
__exportStar(_SdtfTypeGuards, exports);
__exportStar(_SdtfUtils, exports);
__exportStar(_ISdtfBaseWriteableComponent, exports);
__exportStar(_ISdtfWriteableAccessor, exports);
__exportStar(_ISdtfWriteableAsset, exports);
__exportStar(_ISdtfWriteableAttributes, exports);
__exportStar(_ISdtfWriteableBuffer, exports);
__exportStar(_ISdtfWriteableBufferView, exports);
__exportStar(_ISdtfWriteableChunk, exports);
__exportStar(_ISdtfWriteableDataItem, exports);
__exportStar(_ISdtfWriteableFileInfo, exports);
__exportStar(_ISdtfWriteableNode, exports);
__exportStar(_ISdtfWriteableTypeHint, exports);
__exportStar(_ISdtfWriteableComponentFactory, exports);
__exportStar(_SdtfError, exports);
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  SdtfTypeHintName = exports.SdtfTypeHintName,
  SdtfRhinoTypeHintName = exports.SdtfRhinoTypeHintName,
  SdtfGrasshopperTypeHintName = exports.SdtfGrasshopperTypeHintName,
  SdtfGeometryTypeHintName = exports.SdtfGeometryTypeHintName,
  SdtfPrimitiveTypeHintName = exports.SdtfPrimitiveTypeHintName,
  isNumeric = exports.isNumeric,
  isNumber = exports.isNumber,
  isInt = exports.isInt,
  isUint = exports.isUint,
  isNonEmptyString = exports.isNonEmptyString,
  isNumberArray = exports.isNumberArray,
  isIntArray = exports.isIntArray,
  isUintArray = exports.isUintArray,
  isDataObject = exports.isDataObject,
  isBinaryData = exports.isBinaryData,
  isNil = exports.isNil,
  isSdtfError = exports.isSdtfError,
  sdAssertUnreachable = exports.sdAssertUnreachable,
  enumKeys = exports.enumKeys,
  enumValues = exports.enumValues,
  tryDeepCopy = exports.tryDeepCopy,
  SdtfError = exports.SdtfError,
  SdtfErrorType = exports.SdtfErrorType;